import { Font, StyleSheet, Text } from '@react-pdf/renderer';
import parse, { DOMNode, Element, domToReact } from 'html-react-parser';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Thin.ttf', fontWeight: 100 },
    { src: '/Lato-Light.ttf', fontWeight: 300 },
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
    { src: '/Lato-Black.ttf', fontWeight: 900 },
    { src: '/Lato-ThinItalic.ttf', fontWeight: 100, fontStyle: 'italic' },
    {
      src: '/Lato-LightItalic.ttf',
      fontWeight: 300,
      fontStyle: 'italic',
    },
    {
      src: '/Lato-RegularItalic.ttf',
      fontWeight: 400,
      fontStyle: 'italic',
    },
    { src: '/Lato-BoldItalic.ttf', fontWeight: 700, fontStyle: 'italic' },
    {
      src: '/Lato-BlackItalic.ttf',
      fontWeight: 900,
      fontStyle: 'italic',
    },
  ],
});

export const styles = StyleSheet.create({
  section: {
    margin: 10,
    padding: 10,
    flexGrow: 1,
  },
  text: {
    fontSize: 12,
  },
  h1: {
    fontSize: 24,
    marginBottom: 10,
  },
  p: {
    marginBottom: 10,
  },
  strong: {
    fontWeight: 'bold',
  },
  em: {
    fontStyle: 'italic',
  },
  a: {
    color: 'blue',
    textDecoration: 'underline',
  },
});

export const replaceWithComponent = (html: string, disabledStyle?: boolean) => {
  const isElement = (node: DOMNode): node is Element => {
    return !!(node as Element).tagName;
  };

  const convertNode = (
    element: Element,
    index: number
  ): React.ReactNode | null => {
    const { name, children } = element;
    if (!children) return null;
    const key = `key-${index}`;
    switch (name) {
      case 'h1':
        return (
          <Text key={key} style={disabledStyle ? {} : styles.h1}>
            {domToReact(children as DOMNode[], convertOptions)}
          </Text>
        );
      case 'p':
        return (
          <Text key={key} style={disabledStyle ? {} : styles.p}>
            {domToReact(children as DOMNode[], convertOptions)}
          </Text>
        );
      case 'strong':
        return (
          <Text key={key} style={disabledStyle ? {} : styles.strong}>
            {domToReact(children as DOMNode[], convertOptions)}
          </Text>
        );
      case 'em':
        return (
          <Text key={key} style={disabledStyle ? {} : styles.em}>
            {domToReact(children as DOMNode[], convertOptions)}
          </Text>
        );
      case 'a':
        return (
          <Text key={key} style={disabledStyle ? {} : styles.a}>
            {domToReact(children as DOMNode[], convertOptions)}
          </Text>
        );
      default:
        return (
          <Text key={key}>
            {domToReact(children as DOMNode[], convertOptions)}
          </Text>
        );
    }
  };

  const convertOptions = {
    replace: (domNode: DOMNode): any => {
      if (isElement(domNode)) {
        return convertNode(domNode, 0);
      }
      return null;
    },
  };

  return parse(html, convertOptions);
};
